import axios from 'axios'

function requestRegistMemo(parameter){
	return axios.post(`${process.env.VUE_APP_BASEURL}/api/app/memo/regist/memo`, parameter.memo)
}

export {
	requestRegistMemo
}
